import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

export const EmptyStateDescription = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  text-align: center;
  display: flex;
`

export const HereDescription = styled(Text)`
  margin-left: 5px;
  margin-right: 5px;
  text-decoration: underline;
`
